import { applyThemePreference, getThemePreference, type ThemePreference } from '../ui/theme.js';
import { createPageShell } from '../ui/pageShell.js';
import { el } from '../ui/dom.js';
import { btn } from '../ui/dom.js';

export function mountSettingsApp(root: HTMLElement): void {
  root.innerHTML = '';
  root.className = 'app-view circuits-app';

  const { page, body } = createPageShell({
    title: 'Paramètres',
    subtitle: 'Apparence et préférences d’affichage.',
    breadcrumbs: [{ label: 'Tableau de bord', href: '#dashboard' }, { label: 'Paramètres' }],
  });

  const section = el('section', { class: 'card settings-card' });
  section.appendChild(el('h2', { class: 'hub-card-title', text: 'Thème' }));
  const p = el('p', {
    class: 'page-subtitle',
    text: 'Choisissez l’apparence de l’interface. Le bouton dans la barre de navigation reste un raccourci.',
  });
  p.style.marginBottom = '1rem';
  section.appendChild(p);

  const fieldset = el('fieldset', { class: 'field' });
  fieldset.setAttribute('role', 'radiogroup');
  fieldset.setAttribute('aria-label', 'Thème d’affichage');

  const options: { value: ThemePreference; label: string }[] = [
    { value: 'system', label: 'Système (suivre Windows / navigateur)' },
    { value: 'light', label: 'Clair' },
    { value: 'dark', label: 'Sombre' },
  ];

  const current = getThemePreference();

  options.forEach((opt) => {
    const label = el('label', { class: 'label' });
    const row = el('div', { class: 'settings-theme-option' });
    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'theme-pref';
    input.value = opt.value;
    input.checked = current === opt.value;
    input.addEventListener('change', () => {
      if (input.checked) applyThemePreference(opt.value);
    });
    row.appendChild(input);
    row.appendChild(document.createTextNode(opt.label));
    label.appendChild(row);
    fieldset.appendChild(label);
  });

  section.appendChild(fieldset);

  const actions = el('div', { class: 'page-actions' });
  actions.style.marginTop = '1rem';
  actions.appendChild(
    btn('Retour au tableau de bord', { variant: 'ghost' }, () => {
      window.location.hash = 'dashboard';
    })
  );
  section.appendChild(actions);

  body.appendChild(section);
  root.appendChild(page);
}
